var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.713,
    height: 21.713,
    viewBox: "0 0 21.713 21.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-dashboard-5395742",
    d: "M112.755,46.632a2.326,2.326,0,0,0-2.326-2.326h-3.1A2.326,2.326,0,0,0,105,46.632v7.755a2.326,2.326,0,0,0,2.326,2.326h3.1a2.326,2.326,0,0,0,2.326-2.326Zm13.959,4.653a2.326,2.326,0,0,0-2.326-2.326h-7.755a2.326,2.326,0,0,0-2.326,2.326v3.1a2.326,2.326,0,0,0,2.326,2.326h7.755a2.326,2.326,0,0,0,2.326-2.326Zm0-13.959A2.326,2.326,0,0,0,124.387,35h-3.1a2.326,2.326,0,0,0-2.326,2.326v7.755a2.326,2.326,0,0,0,2.326,2.326h3.1a2.326,2.326,0,0,0,2.326-2.326Zm-9.306,0A2.326,2.326,0,0,0,115.081,35h-7.755A2.326,2.326,0,0,0,105,37.326v3.1a2.326,2.326,0,0,0,2.326,2.326h7.755a2.326,2.326,0,0,0,2.326-2.326Z",
    transform: "translate(-105 -35)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDashboard);
export default __webpack_public_path__ + "static/media/SvgDashboard.d31bbd00f18551c4e5b79bff8efe5a64.svg";
export { ForwardRef as ReactComponent };